import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";
import { getConsent, setConsent, openCookiePreferences } from "../lib/consent";

const CATEGORIES = [
  ["necessary", "Necessari", "Sicurezza, sessione di accesso e funzionamento del sito. Sempre attivi.", true],
  ["analytics", "Analytics", "Misurazione anonima dell'uso del sito (es. GA4) per migliorare i contenuti.", false],
  ["marketing", "Marketing", "Eventuali strumenti pubblicitari e di remarketing.", false],
];

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);
  const [customizing, setCustomizing] = useState(false);
  const [choices, setChoices] = useState({ analytics: false, marketing: false });

  useEffect(() => {
    if (!getConsent()) setVisible(true);
    const reopen = () => { setCustomizing(true); setVisible(true); };
    window.addEventListener("flash:open-cookie-prefs", reopen);
    return () => window.removeEventListener("flash:open-cookie-prefs", reopen);
  }, []);

  if (!visible) return null;

  const save = (consent) => {
    setConsent({ necessary: true, ...consent });
    setVisible(false);
    setCustomizing(false);
  };

  return (
    <div data-testid="cookie-banner" className="fixed bottom-0 inset-x-0 z-50 p-4 sm:p-6 pointer-events-none" role="dialog" aria-label="Preferenze cookie">
      <div className="max-w-3xl mx-auto bg-[#171717] text-white rounded-2xl shadow-2xl p-6 pointer-events-auto">
        <div className="flex items-start gap-3">
          <Cookie size={20} className="text-[#F26522] shrink-0 mt-0.5" />
          <div className="flex-1">
            <div className="font-display font-bold text-sm">La tua privacy</div>
            <p className="text-xs text-white/60 mt-1 leading-relaxed">
              Usiamo cookie tecnici per far funzionare il sito e, solo con il tuo consenso, cookie di misurazione.
              Leggi la <Link to="/cookie" className="underline text-[#FFC400]">Cookie Policy</Link>.
            </p>

            {customizing && (
              <div className="mt-4 space-y-2.5" data-testid="cookie-customize">
                {CATEGORIES.map(([key, label, desc, locked]) => (
                  <label key={key} className="flex items-start gap-3 text-xs cursor-pointer">
                    <input
                      type="checkbox"
                      data-testid={`cookie-cat-${key}`}
                      checked={locked || choices[key]}
                      disabled={locked}
                      onChange={(e) => setChoices({ ...choices, [key]: e.target.checked })}
                      className="w-4 h-4 mt-0.5 accent-[#F26522]"
                    />
                    <span>
                      <span className="font-semibold">{label}</span>
                      <span className="block text-white/50 leading-snug">{desc}</span>
                    </span>
                  </label>
                ))}
              </div>
            )}

            <div className="flex flex-wrap gap-2 mt-4">
              <button
                data-testid="cookie-accept-all"
                onClick={() => save({ analytics: true, marketing: true })}
                className="bg-[#F26522] hover:bg-[#D94E0F] text-white text-xs font-semibold rounded-full px-5 py-2.5 transition-colors"
              >
                Accetta tutti
              </button>
              <button
                data-testid="cookie-reject"
                onClick={() => save({ analytics: false, marketing: false })}
                className="border border-white/20 text-white text-xs font-semibold rounded-full px-5 py-2.5 hover:bg-white/10 transition-colors"
              >
                Rifiuta non essenziali
              </button>
              {customizing ? (
                <button
                  data-testid="cookie-save-custom"
                  onClick={() => save(choices)}
                  className="border border-[#FFC400]/50 text-[#FFC400] text-xs font-semibold rounded-full px-5 py-2.5 hover:bg-[#FFC400]/10 transition-colors"
                >
                  Salva preferenze
                </button>
              ) : (
                <button
                  data-testid="cookie-customize"
                  onClick={() => setCustomizing(true)}
                  className="text-white/60 text-xs font-semibold rounded-full px-4 py-2.5 hover:text-white"
                >
                  Personalizza
                </button>
              )}
            </div>
          </div>
          <button onClick={() => save({ analytics: false, marketing: false })} aria-label="Chiudi" className="text-white/40 hover:text-white shrink-0">
            <X size={16} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
export { openCookiePreferences };
